export default __webpack_public_path__ + "static/media/mercy_health_small_logo.b6221615.png";